import { PropOptionSelect } from '@/models'

const ABSENT = 0
const ATTEND = 1

const TIME_INIT_DAY = '06:00:00'
const LIMIT_TIME_DAY = '22:00:00'

const CONDITIONS: PropOptionSelect[] = [
  {
    text: 'Asistió',
    value: ATTEND
  },
  {
    text: 'Ausente',
    value: ABSENT
  }
]

export {
  CONDITIONS,
  ABSENT,
  ATTEND,
  LIMIT_TIME_DAY,
  TIME_INIT_DAY
}
